import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('batteryCard');

    return {
        AGING: t('aging'),
        CYCLE_LIFE: t('cycleLife'),
        CYCLES: t('cycles'),
        CYCLES_VALUE: (used: number, total: number) => t('cyclesValue', { total, used }),
        OK: t('ok'),
        SYNCED: (time: string) => t('synced', { time }),
        USED_WITH: t('usedWith')
    };
};

export default useTranslation;
